<template>
  <div class="Reportform">
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      inline
      label-width="4.8vw"
      style="margin-top: 20px"
    >
      <el-form-item prop="branchCompanyId" label="选择分公司" v-if="[1].includes(UserInfo.type)">
        <el-select
          filterable
          v-model="formScreen.branchCompanyId"
          value-key="company_id"
          @change="selectChange($event, 'listSonCompany')"
        >
          <el-option
            v-for="item in listBranchCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sonCompanyId" label="选择子公司" v-if="[2, 1].includes(UserInfo.type)">
        <el-select
          filterable
          v-model="formScreen.sonCompanyId"
          value-key="rid"
          @change="selectChange($event, 'listDepartment')"
        >
          <el-option
            v-for="item in listSonCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择平台" prop="sellerType">
				<el-select
					v-model="formScreen.sellerType"
					placeholder="请选择"
					@change="shopChange8"
					clearable
				>
					<el-option
						v-for="item in platform"
						:key="item.sellerType"
						:label="item.itemTypeName"
						:value="item.sellerType"
					></el-option>
				</el-select>
			</el-form-item>
      <el-form-item
        prop="departmentVal"
        label="选择分部门"
        v-if="UserInfo.system < 3 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.departmentVal"
          value-key="rid"
          @change="selectChange($event, 'listGroup')"
        >
          <el-option
            v-for="item in listDepartment"
            :key="item.rid"
            :label="item.departmentName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="groupVal"
        label="选择组"
        v-if="UserInfo.system < 4 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.groupVal"
          value-key="rid"
          @change="selectChange($event, 'listStaff')"
        >
          <el-option
            v-for="item in listGroup"
            :key="item.rid"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        prop="staffVal"
        label="选择员工"
        v-if="UserInfo.system < 5 || UserInfo.superDepartmentName === '客服部' || (UserInfo.system === 5 && UserInfo.superDepartmentName === '财务部') || (UserInfo.type === 2 && UserInfo.superDepartmentName === '商务部') || (UserInfo.system === 5 && UserInfo.superDepartmentName === '人事部')"
      >
        <el-select
          v-model="formScreen.staffVal"
          value-key="rid"
          @change="selectChange($event, 'none')"
        >
          <el-option
            v-for="item in listStaff"
            :key="item.rid"
            :label="item.roleUserName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="sid" label="选择店铺">
        <el-select v-model="formScreen.sid" :disabled="isShopDisabled">
          <el-option
            v-for="item in listShop"
            :key="item.id"
            :label="item.shop_name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="uid" label="选择用户">
        <el-select v-model="formScreen.uid" @change="changeUser">
          <el-option :label="item.userName" :value="item.uid" v-for="item in userList" :key="item.uid"></el-option>
        </el-select>
      </el-form-item>
      <br/>
      <el-form-item prop="countryMark" label="国家">
        <el-select v-model="formScreen.countryMark" filterable clearable>
          <el-option
            v-for="item in listCountry"
            :key="item.id"
            :label="item.countryName"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="eventType" label="事件类型">
        <el-select v-model="formScreen.eventType" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'ss'" v-for="(item, index) in eventTypeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="eventReason" label="事件原因">
        <el-select v-model="formScreen.eventReason" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'dd'" v-for="(item, index) in eventReasonList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="status" label="事件状态">
        <el-select v-model="formScreen.status" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'ff'" v-for="(item, index) in statusList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="liquidity" label="资金流动">
        <el-select v-model="formScreen.liquidity" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'gg'" v-for="(item, index) in liquidityList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="settlementType" label="结算类型">
        <el-select v-model="formScreen.settlementType" filterable clearable>
          <el-option :label="item" :value="item" :key="index+'hh'" v-for="(item, index) in settlementTypeList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="xiugaiTime" label="时间范围" style="width: 30%">
        <el-date-picker
          v-model="formScreen.xiugaiTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="searchVal" label=" " style="width: 40%">
        <el-input
          placeholder="请输入订单号/订单ID"
          v-model="formScreen.searchVal"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="searchForm" :loading="searchBtnLoading">搜索</el-button>
        <el-button type="primary" @click="resetForm" :loading="searchBtnLoading">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="table-batch">
      <div>
        <el-button type="danger" style="margin-right: 10px;opacity: 0;">
          批量删除
        </el-button>
      </div>
      <div>
        <el-button type="primary" style="margin-right: 10px;" @click="setData">
          Paypal争议手续费设置
        </el-button>
        <el-button type="primary" style="margin-right: 10px;" @click="dialogImportVisible=true">
          Paypal争议费导入
        </el-button>
      </div>
    </div>
    <el-table key="third" :data="listTable" border v-loading="loadingTable">
      <el-table-column label="订单号/原始交易号" align="center" width="200">
        <template slot-scope="scope">
          <p>订单号：{{ scope.row.amazonOrderId }}</p>
					<p>原始交易号：{{ scope.row.transactionNumber }}</p>
        </template>
      </el-table-column>
      <el-table-column align="left" label="产品信息" header-align="center" width="350">
        <template slot-scope="scope">
          <div
            class="details"
            v-for="(item, index) in scope.row.orderItemsList"
            :key="index"
          >
            <div class="details_left">
              <el-popover
                trigger="hover"
                placement="right"
                prop="orderItemsList.imageUrl"
                v-if="item.imageUrl"
              >
                <img
                  referrer="no-referrer|origin|unsafe-url"
                  :src="item.imageUrl"
                  alt
                  style="width:500px;height:500px;"
                />
                <div class="scope_img" slot="reference">
                  <img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
                </div>
              </el-popover>
              <el-button
                type="text"
                size="mini"
                v-else
                @click="getOriginalImg(item)"
                style="padding: 0;"
                >查看原图</el-button
              >
            </div>
            <div class="details_right">
              <!-- <div
                style="width: 100%;"
                v-if="!scope.row.money"
              >
                <strong>price:</strong> - -
              </div> -->
              <div
                style="width: 100%;"
                v-if="scope.row.money"
              >
                <strong style="color:black">price:</strong> {{ item.itemAmount }}
                {{ item.itemCurrencyCode }}
              </div>
              <div
                style="width: 100%;"
                v-if="item.property !== null"
              >
                <strong style="color:black;">属性:</strong> {{ item.property }}
              </div>
              <div
                style="width: 100%;"
                v-if="item.customizeInfo"
              >
                <strong style="color:black;">定制信息:</strong> {{ item.customizeInfo }}
              </div>
              <div style="width: 100%;color:#dc143c" v-show="item.systemSku">
                <strong>系统SKU:</strong> {{ item.systemSku }}
              </div>
              <div style="width: 100%;">
                <strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
              </div>
              <div style="width: 100;" v-show="item.productSku">
                <strong style="color:black">产品SKU:</strong> {{ item.productSku }}
              </div>
              <!-- <div style="width: 100%;" v-if="scope.row.seller.sellerType == 2">
                海逊SKU: {{ item.sellerSKU }}
              </div> -->
              <el-divider v-if="scope.row.orderItemsList.length>1 && index!=(scope.row.orderItemsList.length-1)" class="orderDivider" />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="countryName" label="国家" align="center"></el-table-column>
      <el-table-column prop="eventType" label="事件类型" align="center"></el-table-column>
      <el-table-column prop="eventReason" label="事件原因" align="center"></el-table-column>
      <el-table-column prop="eventSubmissionDate" label="事件提交日期" align="center"></el-table-column>
      <el-table-column prop="status" label="事件状态" align="center"></el-table-column>
      <el-table-column prop="totalAmount" label="争议金额" align="center"></el-table-column>
      <el-table-column prop="currency" label="币种" align="center"></el-table-column>
      <el-table-column prop="totalPlatformCost" label="争议交易号/交易账单号" align="center" width="200">
        <template slot-scope="scope">
          <p>争议交易号：{{ scope.row.transactionNumber }}</p>
					<p>交易账单号：{{ scope.row.accountNumber }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="liquidity" label="资金流动" align="center"></el-table-column>
      <el-table-column prop="settlementType" label="结算类型" align="center"></el-table-column>
      <el-table-column prop="sellerProtection" label="卖家保障" align="center"></el-table-column>
      <!-- <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="RenewalVisible=true">新增续费</el-button>
          <el-button type="primary" size="small" @click="historyVisible=true">查看历史记录</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-row type="flex" justify="center" align="middle" class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="page"
        :page-sizes="[20, 20, 50, 100]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog
      title="Paypal争议手续费设置"
      :visible.sync="dialogVisible"
      width="30%"
      @close="closeDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="130px" class="dataForm">
        <el-form-item label="Paypal争议手续费" prop="handlingFee">
          <el-input-number v-model="dataForm.handlingFee" size="mini" :min="0" :controls="true" controls-position="both">
          </el-input-number>
          <el-select v-model="dataForm.currency" placeholder="币种" filterable style="margin-left: 10px; width: 120px">
            <el-option
              v-for="item in exchangeRateList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          /单
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" :loading="btnSetLoading" @click="submitSet">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Paypal争议费导入"
      :visible.sync="dialogImportVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      destroy-on-close
    >
      <el-row type="flex" align="middle">
        <upload-excel-component :on-success="handleUploadExcelSuccess"/>
        <!-- <el-button style="margin-left: 10px;" @click="downloadTemplate">下载模板</el-button> -->
      </el-row>
      <div class="file-box">
        <span style="color: red">注意：时间格式按照“2022/10/10”填写，该时区为美东-4时区时间。</span>
      </div>
      <div class="file-box">
        <div v-for="(item, index) in listFile" :key="index">{{ `${ index + 1 }. ${ item.fileName }` }}</div>
      </div>
      <div class="file-box" v-show="errorList">
        <div><span style="color: red">导入异常信息：</span></div>
        <span v-for="(item, index) in errorList" :key="index+'w'">{{ item }}<br /></span>
      </div>
      <div slot="footer">
        <el-button
          size="small"
          :loading="btnLoading"
          @click="handleUploadExcelSubmit"
        >确定导入
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="新增续费" width="25%" :visible.sync="RenewalVisible">
      <el-form label-width="100px">
        <el-form-item label="独立站平台">
          shopline
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="套餐选择">
          <el-select v-model="formData.taocan" filterable>
            <el-option label="套餐1" value="1"></el-option>
            <el-option label="套餐2" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月租">
          39.99 USD
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="手续费">
          0.2%
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker
            v-model="formData.value1"
            type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="有效时间">
          <el-select v-model="formData.taocan1" filterable>
            <el-option label="1年" value="1"></el-option>
            <el-option label="2年" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="失效时间">
          2023年12月31日
          <el-input type="hidden" style="display: none"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="RenewalVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="RenewalVisible = false"
          :loading="loadingStatus === 'RenewalVisible'"
        >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看历史记录" width="50%" :visible.sync="historyVisible">
      <div slot="title" class="historyTitle">
        <div>查看历史记录</div>
        <div>独立站平台: shopline</div>
      </div>
      <ul class="historyUl">
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>试用期</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              免费天数 <strong>7</strong> 天
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2022年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              试用期间费率 <strong>0.2%</strong>
            </el-col>
          </el-row>
        </li>
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>续费期一</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2022年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              结束时间 <strong>2023年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              期间费率 <strong>0.2%</strong>
            </el-col>
          </el-row>
        </li>
        <li>
          <el-row :gutter="20">
            <el-col :span="3" :offset="0">
              <strong>续费期二</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              起始时间 <strong>2023年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              结束时间 <strong>2024年1月1日</strong>
            </el-col>
            <el-col :span="7" :offset="0">
              期间费率 <strong>0.7%</strong>
            </el-col>
          </el-row>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>
<script>
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import { ajaxPost, Baseurl } from '@/api/api/api';
export default {
  name: "DisputeFee",
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick: (picker) => {
            const date = new Date()
            picker.$emit('pick', date);
            this.calculationDate()
          }
        }, {
          text: '上一月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-1)
          }
        }, {
          text: '上两月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-2)
          }
        }, {
          text: '上三月',
          onClick: (picker) => {
            const date = new Date();
            picker.$emit('pick', date);
            this.calculationDate(-3)
          }
        }]
      },
      UserInfo: {},
      companyId: '',
      rid: '',
      system: '',
      formScreen: {
        branchCompanyId: '',
        sonCompanyId: '',
        departmentVal: '',
        groupVal: '',
        staffVal: '',
        sid: '',
        startTime: '',
        endTime: '',
        searchVal: '',
        sellerType: '',
        xiugaiTime: []
      },
      listBranchCompany: [],
      listSonCompany: [],
      listDepartment: [],
      listGroup: [],
      listStaff: [],
      listShop: [],
      dialogVisible: false,
      withdrawalRatio2: '',
      loadingStatus: '',
      listTable: [],
      loadingTable: false,
      page: 1,
      size: 20,
      total: 0,
      platform: [],
      searchBtnLoading: false,
      formData: {},
      RenewalVisible: false,
      historyVisible: false,
      dataForm: {},
      rules: {},
      exchangeRateList: [],
      dialogImportVisible: false,
      returnList: [],
      listFile: [],
      errorList: '',
      btnLoading: false,
      shopIds: [],
      listCountry: [],
      btnSetLoading: false,
      eventReasonList: [],
      eventTypeList: [],
      liquidityList: [],
      settlementTypeList: [],
      statusList: [],
      userList: [],
      sidList: []
    };
  },
  computed: {
    isShopDisabled() {
      if (this.UserInfo.system === 5 && this.UserInfo.superDepartmentName === '运营部') {
        return false
      } else {
        return !this.formScreen.staffVal
      }
    },
    screenObj() {
      return {
        companyId: this.companyId,
        rid: this.rid,
        system: this.system,
        sid: this.formScreen.sid,
      }
    }
  },
  watch: {
    dialogImportVisible(val) {
      if (!val) {
        this.listFile = []
        this.errorList = ''
      }
    }
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem('role'))
    this.companyId = this.UserInfo.company_id
    this.rid = this.UserInfo.rid
    this.system = this.UserInfo.system

    this.init()
    this.getTable()
    this.getListCountry()
    this.getExchangeRateList()
    this.getSelectData()
    this.getUsers()
    if(this.UserInfo.type===3){
			this.getPlatform();
		}
  },
  methods: {
    init() {
      const { rid, system, company_id: companyId, type } = this.UserInfo;
      let listType = "";
      if (type === 1) {
        listType = "listBranchCompany";
      } else if (type === 2) {
        listType = "listSonCompany";
      } else {
        listType = "listDepartment";
      }
      if (type === 3) {
        if (system === 3) {
          listType = "listGroup";
        } else if (system === 4) {
          listType = "listStaff";
        }
      }
      this.getNextPower(rid, system, companyId, listType);
    },
    setData() {
      this.getSetData()
      this.dialogVisible = true
    },
    getSetData() {
      const API = Baseurl + 'paypalDisputeHandlingFeeController/selectPaypalDisputeHandlingFee'
      const paramsData = {
        companyId: this.UserInfo.company_id
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.data) {
          this.dataForm = res.data.data
        }
      })
    },
    getUsers() {
      const API = Baseurl + 'userControllers/selectUserListAndSidListByCompanyId'
      const paramsData = {
        companyId: this.UserInfo.company_id
      }
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.userList = res.data.data
        } else {
          this.userList = []
          this.$message.error(res.data.data)
        }
      })
    },
    getListCountry() {
			const API =
				Baseurl +
				'logisticsConfigurationController/selectLogisticsCountryList'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listCountry = data
				}
			})
		},
    getSelectData() {
			const API =
				Baseurl +
				'paypalDisputeController/getPaypalDisputeSearchCondition'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
          this.eventReasonList = data.eventReasonList
          this.eventTypeList = data.eventTypeList
          this.liquidityList = data.liquidityList
          this.settlementTypeList = data.settlementTypeList
          this.statusList = data.statusList
				}
			})
		},
    // 获取汇率列表
		getExchangeRateList() {
			ajaxPost(Baseurl + 'rateController/getRatecurrencyCodeList').then((res) => {
				const { data: responseData } = res
				if (responseData.code === 200) {
					const { data } = responseData
					this.exchangeRateList = data
				}
			})
		},
    shopChange8() {
      if(this.UserInfo.type !== 3){
        this.rid = this.formScreen.sonCompanyId.rid;
        this.system = this.UserInfo.system;
      } else {
        this.rid = this.UserInfo.rid;
        this.system = this.UserInfo.system;
      }
      this.getNextPower(this.rid, this.system, this.companyId, 'listDepartment', true);
      this.formScreen.departmentVal = '';
      this.formScreen.groupVal = '';
      this.formScreen.staffVal = '';
      this.listStaff = [];
      this.formScreen.sid = '';
      this.listShop = []
      this.listGroup = [];
    },
    getPlatform() {
      const API = Baseurl + 'sellerController/selectStandalonePlatformList'
      ajaxPost(API, {rid: this.UserInfo.rid}).then((res) => {
        if(res.data.code === 200) {
          this.platform = res.data.data
        }else{
          this.platform=[]
          this.$message.error(res.data.data)
        }
      })
    },
    getNextPower(rid, system, companyId, type, bool=false) {
      const API = Baseurl + "roleController/selectNextAndSellerInfoByRid";
      let paramsData = { rid, system, companyId, sellerType: this.formScreen.sellerType };

      ajaxPost(API, paramsData).then(res => {
        const {
          data: { code, data },
        } = res;
        if (code === 200) {
          this[type] = data.next;
          if (bool) {
            this.shopIds = data.shopIds;
          }
        }
      });
    },
    selectChange(event, type) {
      this.formScreen.uid = ''
      const { rid, system, company_id: companyId } = event;
      companyId && (this.companyId = companyId);
      rid && (this.rid = rid);
      system && (this.system = system);
      if (!system) this.system = this.UserInfo.system;
      if (!companyId) this.companyId = this.UserInfo.company_id;
      if (!rid) this.rid = this.UserInfo.rid;

      this.listShop = []
      this.formScreen.sid = ''
      if (type === "none") {
        this.getListShop()
        return;
      }
      this.getNextPower(rid, system, companyId, type, true);

      if (type == "listDepartment") {
        this.getPlatform();
      }

      this.formScreen.staffVal = {};
      this.listStaff = [];
      if (type === "listStaff") return;
      this.formScreen.groupVal = {};
      this.listGroup = [];
      if (type === "listGroup") return;
      this.formScreen.departmentVal = {};
      this.listDepartment = [];
      this.formScreen.sellerType = '';
      this.platform = [];
      if (type === "listDepartment") return;
      this.formScreen.sonCompanyId = {};
      this.listSonCompany = [];
    },
    changeUser() {
      this.formScreen.sellerType = ''
      this.formScreen.departmentVal = ''
      this.formScreen.groupVal = ''
      this.formScreen.staffVal = ''
      this.formScreen.sid = ''
      this.sidList = this.userList.filter(x => x.uid == this.formScreen.uid)[0].sidList
    },
    getTable() {
      const API = Baseurl + 'paypalDisputeController/selectPaypalDisputePageInfo'
      const paramsData = {
        page: this.page,
        size: this.size,
        startTime: this.formScreen.xiugaiTime?this.formScreen.xiugaiTime[0]:'',
        endTime: this.formScreen.xiugaiTime?this.formScreen.xiugaiTime[1]:'',
        searchString: this.formScreen.searchVal,
        sellerType: this.formScreen.sellerType,
        shopIds: this.shopIds,
        sidList: this.sidList,
        eventReason: this.formScreen.eventReason,
        eventType: this.formScreen.eventType,
        liquidity: this.formScreen.liquidity,
        settlementType: this.formScreen.settlementType,
        status: this.formScreen.status,
        ...this.screenObj
      }
      this.loadingTable = true

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingTable = false
        this.searchBtnLoading = false
        if (code === 200) {
          // data.list.forEach(item => item.amountChina = item.money.amountChina)
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    getListShop() {
      const API = Baseurl + 'sellerController/selectMyShopByRid1'
      const paramsData = {
        rid: this.rid,
        system: this.system
      }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listShop = data
        }
      })
    },
    searchForm() {
      this.searchBtnLoading = true
      this.page = 1
      this.getTable()
    },
    resetForm() {
      this.page = 1
      this.$refs.formScreen.resetFields();
      this.listBranchCompany = [];
      this.listSonCompany = [];
      this.listDepartment = [];
      this.listGroup = [];
      this.listStaff = [];
      this.listShop = [];
      this.sidList = [];
      this.shopIds = [];
      this.rid = this.UserInfo.rid
      this.system = this.UserInfo.system
      this.companyId = this.UserInfo.company_id

      this.init();
      this.searchForm()
    },
    handleSizeChange1(val) {
      this.size = val
      this.getTable()
    },
    handleCurrentChange1(val) {
      this.page = val
      this.getTable()
    },
    calculationDate(type = 0) {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 计算新的月份和年份，确保处理负数和跨年的情况
      const newYear = year + Math.floor((month + type - 1) / 12);
      const newMonth = (month + type - 1 + 12) % 12 + 1;
      this.formScreen.startTime = `${newYear}-${newMonth.toString().padStart(2, '0')}-01 00:00:00`;

      const prevStamp = new Date(year, month + type, day).getTime() - (3600 * 1000 * 24 * day)
      const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(prevStamp).getMonth() + 1}-${new Date(prevStamp).getDate()}`
      this.formScreen.endTime = `${prevMonth} 23:59:59`
    },
    updateWithdrawalRatio() {
      const API = Baseurl + 'companyController/updateCompanyWithdrawalRatio'
      const paramsData = {
        id: this.UserInfo.company_id,
      }
      this.loadingStatus = 'dialogVisible'
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        this.loadingStatus = ''
        if (code === 200) {
          this.UserInfo.company = data
          localStorage.setItem('role', JSON.stringify(this.UserInfo))
          this.$message.success('操作成功')
          this.searchForm()
          this.dialogVisible = false
        }
      })
    },
    closeDialog() {},
    handleUploadExcelSuccess({ results, header, fileName }) {
      let returnList = []
      try {
        returnList = results.map(item => ({
          transactionNumber: item.争议交易号,
          referenceTransactionNumber: item.交易号,
          accountNumber: item.账单号,
          // transactionDate: this.formatDate(item.交易日期, '-'),
          transactionDate: item.交易开始日期.replace(/\//g, '\-'),
          // eventSubmissionDate: this.formatDate(item.事件提交日期, '-'),
          eventSubmissionDate: item.事件提交日期.replace(/\//g, '\-'),
          name: item.买家名字 + " " + item.买家姓氏,
          eventType: item.事件类型,
          eventReason: item.事件原因,
          status: item.事件状态,
          totalAmount: item.争议金额,
          currency: item.争议币种,
          disputingPartyEmail: item.买家邮箱地址,
          liquidity: item.资金流动,
          settlementType: item.结算类型,
          sellerProtection: item.卖家保障,
          buyerMessage: item.买家留言,
        }))
      } catch (_) {
        this.$message.error("文件错误，请核对文件格式")
        return
      }
      let bool1 = false
      let bool2 = false
      returnList.map(item => {
        if (item.transactionDate == "NaN-NaN-NaN") {
          bool1 = true
        }
        if (item.eventSubmissionDate == "NaN-NaN-NaN") {
          bool2 = true
        }
      })
      if (bool1 == true) {
        this.$message.error("交易日期格式有误，请按照正确格式填写！")
        return
      }
      if (bool2 == true) {
        this.$message.error("事件提交日期格式有误，请按照正确格式填写！")
        return
      }
      this.returnList.push(...returnList)
      this.listFile.push({fileName})
    },
    formatDate(numb, format) {
      const old = numb - 1;
      const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
      const time = new Date(1900, 0, old, 0, 0, t)
      const year = time.getFullYear() ;
      const month = time.getMonth() + 1 ;
      const date = time.getDate();
      return year + format + (month < 10 ? '0' + month : month) + format + (date < 10 ? '0' + date : date)
    },
    downloadTemplate() {
      const a = document.createElement('a')
      a.href = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.download = 'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E5%B9%BF%E5%91%8A%E8%B4%B9%E6%A8%A1%E6%9D%BF.xls'
      a.click()
      this.$message.success('正在下载...')
    },
    handleUploadExcelSubmit() {
      if (!this.returnList.length) {
        this.$message.error("请先导入文件！")
        return
      }
      this.btnLoading = true
      ajaxPost(
        Baseurl + 'paypalDisputeController/importPaypalDispute/'+this.UserInfo.rid, this.returnList
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("成功导入"+res.data.data.successCount+"条数据")
          if (res.data.data.errorList.length) {
            this.errorList = res.data.data.errorList
          } else {
            this.dialogImportVisible = false
            this.listFile = []
            this.errorList = ''
          }
          this.getTable()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnLoading = false
      })
    },
    submitSet() {
      if (this.dataForm.handlingFee === undefined || this.dataForm.handlingFee === null) {
        this.$message.error("请输入手续费")
        return
      }
      if (!this.dataForm.currency) {
        this.$message.error("请选择币种")
        return
      }
      this.btnSetLoading = true
      ajaxPost(
        Baseurl + 'paypalDisputeHandlingFeeController/setPaypalDisputeHandlingFee', {
          companyId: this.UserInfo.company_id,
          ...this.dataForm
        }
      ).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("设置成功")
          this.closeSet()
        } else {
          this.$message.error(res.data.message)
        }
        this.btnSetLoading = false
      }).catch(() => {
        this.btnSetLoading = false
      })
    },
    closeSet() {
      this.dataForm = {}
      this.dialogVisible = false
    }
  }
};
</script>

<style lang="scss" scoped>
.Reportform {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;
  .details {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.details_left {
		width: 30%;
		text-align: center;
	}
	.details_right {
		width: 70%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
  .scope_img img {
		width: 55px;
		height: 55px;
	}
  .table-batch {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    overflow: hidden;
    line-height: 40px;
    padding-bottom: 3px;
    margin-bottom: 5px;
    padding-top: 3px;
    background-color: #f9f3f3;
  }
  .historyTitle {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    padding-right: 100px;
  }
  .historyUl {
    li {
      margin-bottom: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
      &:last-child {
        border-bottom: none;
      }
    }
  }

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>
